import BkPanel from '../../Components/ui/BkPanel';
import MatchHistory from './MatchHistory';
import type { ProfileData } from './Profile';
import { Link } from 'react-router-dom';

export type ProfileOverviewProps = {
  profile: ProfileData;
  isOwnProfile: boolean;
};

export default function ProfileOverview({
  profile,
  isOwnProfile,
}: ProfileOverviewProps) {
  const games = Array.isArray(profile.games) ? profile.games.slice(0, 5) : [];
  const name = String(profile.displayName || '');

  return (
    <div className="mx-auto w-full max-w-6xl space-y-8 px-4 py-6 sm:px-6 lg:px-10">
      <section className="space-y-3">
        <div className="flex items-end justify-between gap-3">
          <h2 className="text-lg font-bold uppercase tracking-wider text-bk-text">
            Recent matches
          </h2>
          {name ? (
            <Link
              to={`/user/${name}?tab=history`}
              className="text-xs font-bold uppercase tracking-wider text-bk-gold hover:text-bk-gold-bright"
            >
              Full history →
            </Link>
          ) : null}
        </div>
        {games.length ? (
          <MatchHistory games={games} compact />
        ) : (
          <BkPanel className="text-sm text-bk-muted">
            {isOwnProfile
              ? 'No matches yet. Hit Play and make history.'
              : 'No public match history.'}
          </BkPanel>
        )}
      </section>
    </div>
  );
}
